import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    User,
    GraduationCap,
    Calendar,
    Phone,
    Mail,
    Briefcase,
    IdCard,
    Loader2,
    ShieldAlert
} from 'lucide-react';
import { useToast } from '../hooks/useToast';
import Card from '../components/ui/Card';
import {
    fetchParentWardProfile,
    fetchTotalReceivableBalance,
    currencyCodeToSymbolMap,
    fetchCustomerDepositBalance
} from "../apiHelper";

const Dashboard = () => {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [user, setUser] = useState(null);
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);

    const [balances, setBalances] = useState({});
    const [loadingBalances, setLoadingBalances] = useState({});

    const [deposits, setDeposits] = useState({});
    const [loadingDeposits, setLoadingDeposits] = useState({});

    // Verify authentication on component mount
    useEffect(() => {
        const lcUser = localStorage.getItem("user");
        if (!lcUser) {
            showToast("Please log in to view your dashboard.", "info");
            navigate('/login');
        } else {
            setUser(JSON.parse(lcUser));
        }
    }, [showToast, navigate]);

    // Fetch the Parent Profile and Ward Data
    useEffect(() => {
        const loadProfile = async () => {
            if (!user) return;
            setLoading(true);
            try {
                const response = await fetchParentWardProfile();
                // console.log(response)
                setProfileData(response);
            } catch (err) {
                showToast(err.response?.data?.detail || "Error loading profile data", "error");
            } finally {
                setLoading(false);
            }
        };
        loadProfile();
    }, [showToast, user]);

    // // Fetch Receivable Balance for each ward individually
    // useEffect(() => {
    //     const fetchWardBalances = async () => {
    //         if (!profileData || !profileData.wards) return;

    //         profileData.wards.forEach(async (ward) => {
    //             // Prevent duplicate requests if already loading or loaded
    //             if (balances[ward.member_id] !== undefined || loadingBalances[ward.member_id]) return;

    //             setLoadingBalances(prev => ({ ...prev, [ward.member_id]: true }));
    //             try {
    //                 const response = await fetchTotalReceivableBalance({ customer_id: ward.member_id });

    //                 let numericBalance = 0;
    //                 if (typeof response === 'number') {
    //                     numericBalance = response;
    //                 } else if (response && typeof response === 'object') {
    //                     numericBalance =
    //                         response.total_receivable ??
    //                         response.balance ??
    //                         response.amount ??
    //                         response.receivable ??
    //                         0;
    //                 }

    //                 numericBalance = parseFloat(numericBalance) || 0;

    //                 setBalances(prev => ({ ...prev, [ward.member_id]: numericBalance }));
    //             } catch (err) {
    //                 console.error(`Failed to fetch receivable balance for ward ${ward.member_id}:`, err);
    //                 setBalances(prev => ({ ...prev, [ward.member_id]: null }));
    //                 showToast(err.response?.data?.detail || `Could not load balance for ${ward.first_name}`, 'warning');
    //             } finally {
    //                 setLoadingBalances(prev => ({ ...prev, [ward.member_id]: false }));
    //             }
    //         });
    //     };

    //     fetchWardBalances();
    // }, [profileData]);

    // useEffect(() => {
    //     const fetchWardBalances = async () => {
    //         if (!profileData || !profileData.wards) return;

    //         profileData.wards.forEach(async (ward) => {
    //             // Prevent duplicate requests if already loading or loaded
    //             if (balances[ward.member_id] !== undefined || loadingBalances[ward.member_id]) return;

    //             setLoadingBalances(prev => ({ ...prev, [ward.member_id]: true }));
    //             try {
    //                 const response = await fetchTotalReceivableBalance({ customer_id: ward.member_id });

    //                 let numericBalance = 0;
    //                 if (typeof response === 'number') {
    //                     numericBalance = response;
    //                 } else if (response && typeof response === 'object') {
    //                     numericBalance =
    //                         response.total_receivable ??
    //                         response.balance ??
    //                         response.amount ??
    //                         response.receivable ??
    //                         0;
    //                 }

    //                 numericBalance = parseFloat(numericBalance) || 0;

    //                 setBalances(prev => ({ ...prev, [ward.member_id]: numericBalance }));
    //             } catch (err) {
    //                 console.error(`Failed to fetch receivable balance for ward ${ward.member_id}:`, err);
    //                 setBalances(prev => ({ ...prev, [ward.member_id]: null }));
    //                 showToast(err.response?.data?.detail || `Could not load balance for ${ward.first_name}`, 'warning');
    //             } finally {
    //                 setLoadingBalances(prev => ({ ...prev, [ward.member_id]: false }));
    //             }

    //             // --- ADD DEPOSIT FETCH BLOCK HERE ---
    //             if (deposits[ward.member_id] !== undefined || loadingDeposits[ward.member_id]) return;

    //             setLoadingDeposits(prev => ({ ...prev, [ward.member_id]: true }));
    //             try {
    //                 const depResponse = await fetchCustomerDepositBalance(ward.member_id);

    //                 let numericDeposit = 0;
    //                 if (typeof depResponse === 'number') {
    //                     numericDeposit = depResponse;
    //                 } else if (depResponse && typeof depResponse === 'object') {
    //                     numericDeposit =
    //                         depResponse.deposit_balance ??
    //                         depResponse.balance ??
    //                         depResponse.amount ??
    //                         0;
    //                 }

    //                 numericDeposit = parseFloat(numericDeposit) || 0;
    //                 setDeposits(prev => ({ ...prev, [ward.member_id]: numericDeposit }));
    //             } catch (err) {
    //                 console.error(`Failed to fetch deposit balance for ward ${ward.member_id}:`, err);
    //                 setDeposits(prev => ({ ...prev, [ward.member_id]: null }));
    //             } finally {
    //                 setLoadingDeposits(prev => ({ ...prev, [ward.member_id]: false }));
    //             }
    //         });
    //     };

    //     fetchWardBalances();
    // }, [profileData]);


    useEffect(() => {
        if (!profileData?.wards || profileData.wards.length === 0) return;

        const fetchAllWardMetrics = async () => {
            profileData.wards.forEach(async (ward) => {
                const wardId = ward.member_id;

                // Set loading state for this ward
                setLoadingBalances(prev => ({ ...prev, [wardId]: true }));
                setLoadingDeposits(prev => ({ ...prev, [wardId]: true }));

                // Fetch balances and deposits concurrently
                try {
                    const [balRes, depRes] = await Promise.allSettled([
                        fetchTotalReceivableBalance({ customer_id: wardId }),
                        fetchCustomerDepositBalance(wardId)
                    ]);

                    // Handle Balance Result
                    if (balRes.status === 'fulfilled') {
                        const response = balRes.value;
                        const numericBalance = parseFloat(
                            typeof response === 'number'
                                ? response
                                : (response?.total_receivable ?? response?.balance ?? response?.amount ?? 0)
                        ) || 0;
                        setBalances(prev => ({ ...prev, [wardId]: numericBalance }));
                    } else {
                        console.error(`Failed balance for ${wardId}:`, balRes.reason);
                        setBalances(prev => ({ ...prev, [wardId]: null }));
                    }

                    // Handle Deposit Result
                    if (depRes.status === 'fulfilled') {
                        const depResponse = depRes.value;
                        const numericDeposit = parseFloat(
                            typeof depResponse === 'number'
                                ? depResponse
                                : (depResponse?.deposit_balance ?? depResponse?.balance ?? depResponse?.amount ?? 0)
                        ) || 0;
                        setDeposits(prev => ({ ...prev, [wardId]: numericDeposit }));
                    } else {
                        console.error(`Failed deposit for ${wardId}:`, depRes.reason);
                        setDeposits(prev => ({ ...prev, [wardId]: null }));
                    }

                } finally {
                    setLoadingBalances(prev => ({ ...prev, [wardId]: false }));
                    setLoadingDeposits(prev => ({ ...prev, [wardId]: false }));
                }
            });
        };

        fetchAllWardMetrics();
    }, [profileData]);


    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3">
                <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
                <p className="text-sm font-medium text-zinc-500">Loading your dashboard...</p>
            </div>
        );
    }

    if (!profileData) {
        return (
            <div className="p-6 text-center max-w-md mx-auto">
                <Card className="p-8 border-dashed border-zinc-300 bg-zinc-50 flex flex-col items-center">
                    <ShieldAlert size={40} className="text-amber-600 mb-3" />
                    <p className="text-zinc-600 font-medium">No profile data could be recovered.</p>
                </Card>
            </div>
        );
    }

    const { parent, wards } = profileData;

    return (
        <div className="min-h-screen bg-zinc-50/50 p-6 sm:p-8 space-y-8">

            {/* Header Section */}
            <header className="flex flex-col gap-1">
                <p className="text-xs font-bold text-indigo-600 uppercase tracking-wider">
                    Welcome Back
                </p>
                <h1 className="text-3xl font-extrabold text-zinc-900 tracking-tight">
                    {parent.first_name} {parent.last_name}
                </h1>
                <p className="text-sm text-zinc-500">
                    Manage your account details and view your connected wards.
                </p>
            </header>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">

                {/* Left Side: Parent Information Card */}
                <div className="lg:col-span-1">
                    <Card className="p-6 border-zinc-200/60 shadow-sm bg-white space-y-6">
                        <div className="flex items-center gap-4 border-b border-zinc-100 pb-4">
                            <div className="p-3 bg-pink-50 rounded-xl border border-zinc-100 text-zinc-700">
                                <User size={24} />
                            </div>
                            <div>
                                <h2 className="text-lg font-bold text-zinc-900 tracking-tight">
                                    Parent Profile
                                </h2>
                                <p className="text-xs text-zinc-400 font-medium">
                                    ID: {parent.employeeid || 'N/A'}
                                </p>
                            </div>
                        </div>

                        {/* Contact Information Fields */}
                        <div className="space-y-4">
                            <div className="flex items-center gap-3 text-sm text-zinc-600">
                                <Mail size={16} className="text-zinc-400 flex-shrink-0" />
                                <span className="truncate">{parent.email1 || 'No email address'}</span>
                            </div>
                            <div className="flex items-center gap-3 text-sm text-zinc-600">
                                <Phone size={16} className="text-zinc-400 flex-shrink-0" />
                                <span>{parent.phone1 || 'No phone number'}</span>
                            </div>
                            <div className="flex items-center gap-3 text-sm text-zinc-600">
                                <Calendar size={16} className="text-zinc-400 flex-shrink-0" />
                                <span>Registered: {new Date(parent.created_on).toLocaleDateString()}</span>
                            </div>
                        </div>
                    </Card>
                </div>

                {/* Right Side: Wards / Students List Section */}
                <div className="lg:col-span-2 space-y-4">
                    <div className="flex items-center justify-between">
                        <h2 className="text-xl font-bold text-zinc-900 tracking-tight">
                            Registered Wards ({wards?.length || 0})
                        </h2>
                    </div>

                    {wards && wards.length > 0 ? (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {wards.map((ward) => (
                                <Card key={ward.member_id} className="border-zinc-200/60 bg-white shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden flex flex-col justify-between">
                                    {/* Upper Body Context */}
                                    <div className="p-5 space-y-4 flex-grow">
                                        <div className="flex items-start justify-between">
                                            <div className="flex items-center gap-3">
                                                <div className="p-2.5 bg-indigo-50 rounded-lg border border-indigo-100 text-indigo-600">
                                                    <GraduationCap size={20} />
                                                </div>
                                                <div>
                                                    <h3 className="font-bold text-zinc-900 text-base leading-tight">
                                                        {ward.first_name} {ward.middle_name} {ward.last_name}
                                                    </h3>
                                                    <p className="text-xs text-zinc-400 font-medium mt-0.5">
                                                        Student Account
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Ward Metadata Fields */}
                                        <div className="pt-2 border-t border-zinc-50 space-y-2">
                                            <div className="flex items-center gap-2 text-xs text-zinc-600">
                                                <IdCard size={14} className="text-zinc-400" />
                                                <span className="font-mono tracking-tight text-zinc-500">
                                                    {ward.employeeid}
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-2 text-xs text-zinc-600">
                                                <Briefcase size={14} className="text-zinc-400" />
                                                <div className="flex flex-wrap gap-1.5 items-center">
                                                    <span className="text-zinc-500">Roles:</span>
                                                    {ward.roles && ward.roles.length > 0 ? (
                                                        ward.roles.map((r) => (
                                                            <span
                                                                key={r.role_id}
                                                                className="px-2 py-0.5 bg-indigo-50 border border-indigo-100/80 rounded-full font-medium text-indigo-600 text-[10px]"
                                                            >
                                                                {r.role_name}
                                                            </span>
                                                        ))
                                                    ) : (
                                                        <span className="text-zinc-400 italic">None assigned</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Inline Modern Financial Metrics Panel */}
                                        <div className="mt-4 pt-3 border-t border-zinc-100 grid grid-cols-2 gap-2 bg-zinc-50/70 p-3 rounded-xl border border-zinc-100">
                                            <div>
                                                <p className="text-[10px] uppercase font-bold text-zinc-400">Amount Owed</p>
                                                <div className="mt-0.5 text-xs font-bold">
                                                    {loadingBalances[ward.member_id] ? (
                                                        <Loader2 className="w-3 h-3 text-indigo-600 animate-spin mt-1" />
                                                    ) : balances[ward.member_id] !== null ? (
                                                        <span className="text-gmail-red">
                                                            {currencyCodeToSymbolMap['NGN']}{(balances[ward.member_id] ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </span>
                                                    ) : (
                                                        <span className="text-amber-600 italic text-[11px]">Error</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="border-l border-zinc-200/80 pl-3">
                                                <p className="text-[10px] uppercase font-bold text-zinc-400">Available Deposit</p>
                                                <div className="mt-0.5 text-xs font-bold">
                                                    {loadingDeposits[ward.member_id] ? (
                                                        <Loader2 className="w-3 h-3 text-indigo-600 animate-spin mt-1" />
                                                    ) : deposits[ward.member_id] !== null ? (
                                                        <span className="text-gmail-green">
                                                            {currencyCodeToSymbolMap['NGN']}{(deposits[ward.member_id] ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </span>
                                                    ) : (
                                                        <span className="text-amber-600 italic text-[11px]">Error</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Compact Integrated Grid Action Tray */}
                                    <div className="border-t border-zinc-100 bg-zinc-50/50 grid grid-cols-2 divide-x divide-y divide-zinc-100 text-center text-xs font-semibold">
                                        <button
                                            onClick={() => navigate('/dashboard/new-payment', { state: { ward } })}
                                            className="py-3 text-indigo-600 hover:bg-white hover:text-indigo-800 transition-colors cursor-pointer rounded-bl-xl border-b border-zinc-100"
                                        >
                                            Make Payment
                                        </button>
                                        <button
                                            onClick={() => navigate('/invoices', { state: { ward } })}
                                            className="py-3 text-indigo-600 hover:bg-white hover:text-indigo-800 transition-colors cursor-pointer border-b border-zinc-100"
                                        >
                                            View Invoices
                                        </button>
                                        <button
                                            onClick={() => navigate('/history', { state: { memberId: ward.member_id } })}
                                            className="py-3 text-indigo-600 hover:bg-white hover:text-indigo-800 transition-colors cursor-pointer rounded-br-none"
                                        >
                                            View History
                                        </button>
                                        <button
                                            onClick={() => navigate('/history', { state: { ward } })}
                                            className="py-3 text-indigo-600 hover:bg-white hover:text-indigo-800 transition-colors cursor-pointer rounded-br-xl"
                                        >
                                            Receipts
                                        </button>
                                    </div>
                                </Card>
                            ))}
                        </div>
                    ) : (
                        <Card className="p-8 border-dashed border-zinc-300 bg-zinc-50/70 text-center text-zinc-400">
                            No wards or student records are assigned to your parent account.
                        </Card>
                    )}
                </div>

            </div>
        </div>
    );
};

export default Dashboard;

/**
 * parent-ward-profile -> permit parent
 * customer-total-receivable-balance - permit parent
 * fetch-students-deposit - permit parent
 * inventory/services-for-sales - permit parent
 * inventory/inventory-for-sales - permit parent
 * store/fetch-attr - permit parent
 * accounting/discounts - permit parent
 * /school/finalize-school-fees-payment - permit parent
 * /accounting/customer-total-receivable-balance-and-orders - permit parent
 * /school/record-portal-payment - permit parent
 * /school/portal-transactions - permit parent
 * create this transaction type CLEARING_SUB_LEDGER_TRANSFER
 * check transaction types and mappings for new cases, either order indexes or just see latest inserted
 */